import { classnames } from '@aibees/shared/utils';
import { Box, Grid, Typography } from '@mui/material';
import { memo } from 'react';
import { FaqItem } from '../faq-item';
import {
  billingQuestions,
  creditsPricingQuestions,
  generalQuestions,
} from './config';
import * as Styled from './styles';
import * as SX from './sx';
import type { FaqProps as Props } from './types';

export const Faq = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper className={classnames('Faq', className)} sx={SX.root}>
      <Typography variant="h5" my={1}>
        Frequently Asked Questions
      </Typography>
      <Typography variant="body3" mb={5}>
        Everything you need to know for complete peace of mind.
      </Typography>

      <Grid container spacing={1}>
        <Grid item xs={12} sm={4}>
          <Box sx={SX.sectionTitle}>
            <Typography variant="body4" fontWeight={600}>
              General Questions
            </Typography>
          </Box>
          {generalQuestions.map((item) => (
            <FaqItem key={item.id} item={item} />
          ))}
        </Grid>

        <Grid item xs={12} sm={4}>
          <Box sx={SX.sectionTitle}>
            <Typography variant="body4" fontWeight={600}>
              Credits/ Pricing
            </Typography>
          </Box>
          {creditsPricingQuestions.map((item) => (
            <FaqItem key={item.id} item={item} />
          ))}
        </Grid>

        <Grid item xs={12} sm={4}>
          <Box sx={SX.sectionTitle}>
            <Typography variant="body4" fontWeight={600}>
              Billing Questions
            </Typography>
          </Box>
          {billingQuestions.map((item) => (
            <FaqItem key={item.id} item={item} />
          ))}
        </Grid>
      </Grid>
    </Styled.Wrapper>
  );
});

Faq.displayName = 'Faq';
